import React from 'react';
import ProductCardHome from 'components/artectum/cards/product-card-home';
import { ProductGridPropTypes } from '../../../core/propTypes/gridPropTypes';

const ProductGrid = React.memo(({ products, onQuickView }) => {
	const publicUrl =  "/";

	return (
		<div className="row d-flex justify-content-md-start justify-content-center">
			{products?.map((product, index) => (
				<div className="col-xl-4 col-md-4 col-sm-6 col-6 p-0" key={index}>
					{/* {product?.photos && product?.photos?.length > 0 && ( */}
						<ProductCardHome item={product} publicUrl={publicUrl} onQuickView={onQuickView} />
					{/* )} */}
				</div>
			))}
		</div>
	);
});

ProductGrid.propTypes = ProductGridPropTypes;

export default ProductGrid;
